import { SURVEY_BUILDER_POPUP_TYPES } from '../constants';
import { getSampleSizeChargeAmount } from '../getChargeAmount/getChargeAmount';
import getPermissionValue from '../getPermissionValue';

export default (
  survey,
  accountManagement,
  surveyPermissionsCharge,
  defaultPermissionValues
) => {
  const sampleSizeIncludedInLicence = getPermissionValue(
    survey,
    'sampleSizeIncludedInLicence'
  );
  const surveySampleSizeChargeAmount = getSampleSizeChargeAmount(
    survey.maxResponses,
    sampleSizeIncludedInLicence,
    defaultPermissionValues
  );

  const isChargeAmountIncreased =
    (surveyPermissionsCharge &&
      surveyPermissionsCharge.surveySampleSizeChargeAmount === null &&
      surveySampleSizeChargeAmount.total) ||
    (surveyPermissionsCharge &&
      surveyPermissionsCharge.surveySampleSizeChargeAmount &&
      surveySampleSizeChargeAmount.total >
        surveyPermissionsCharge.surveySampleSizeChargeAmount.total);

  const isThereAnyLicence =
    (survey.recordDetails && survey.recordDetails.haveCreditsLeft) ||
    (survey.recordDetails &&
      survey.recordDetails.parent &&
      survey.recordDetails.parent.haveCreditsLeft);

  if (
    isThereAnyLicence &&
    survey.maxResponses !== undefined &&
    survey.maxResponses !== null &&
    isChargeAmountIncreased
  ) {
    return {
      accountManagementSampleSizeWarning:
        SURVEY_BUILDER_POPUP_TYPES.SAMPLE_SIZE_CHARGE_INCREASED,
      surveySampleSizeChargeAmount
    };
  }

  return {
    accountManagementSampleSizeWarning: null,
    surveySampleSizeChargeAmount
  };
};
